import React from 'react';
import ParamClickable from './paramClickable';

interface CommandParamsProps
{
	params: { id: string | number;[key: string]: any }[];
	file: string; // The file identifier for the operation
	index: number; // The index of the operation in the list
}

export default function CommandParams(props: CommandParamsProps)
{
	const params = props.params;

	const drawParams = (() =>
	{
		const result: React.JSX.Element[] = [];
		if (!params) return result;
		for (let i = 0; i < params.length; i++)
		{
			const currentParam = params[i];
			result.push(<ParamClickable {...props} param={currentParam} name={currentParam.name} key={currentParam.id}/>)
		}
		return result;
	})();

	//render
	return (
		<div style={{
			color: 'black',
		}}>
			{drawParams}
		</div>
	)
}
